import React, { useEffect } from "react";
import { clearSession } from "./api";

const BARDE_SESSION_KEY = "astrovoyance.barde_session";
const EMAIL_KEY = "astrovoyance.email";

/**
 * Wipe all local traces AND ask the server to delete chat history +
 * oracle log for the current session/email.
 *
 * Called on: manual "Effacer & partir", browser unload, tab close.
 */
export function purgeEverything(reason = "manual") {
  try {
    const sid = localStorage.getItem(BARDE_SESSION_KEY);
    const email = localStorage.getItem(EMAIL_KEY);
    clearSession(sid, email);
  } catch {
    /* noop */
  }
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch {
    /* noop */
  }
  if (reason === "manual") {
    window.location.href = "/";
  }
}

/** Attaches window listeners that fire the server-side purge on tab close. */
export function useAutoPurgeOnExit(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const handler = () => {
      const sid = localStorage.getItem(BARDE_SESSION_KEY);
      const email = localStorage.getItem(EMAIL_KEY);
      if (sid || email) clearSession(sid, email);
    };
    window.addEventListener("pagehide", handler);
    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("pagehide", handler);
      window.removeEventListener("beforeunload", handler);
    };
  }, [enabled]);
}
